import { render, staticRenderFns } from "./ChangePasswordPage.vue?vue&type=template&id=4c844c3a&scoped=true"
import script from "./ChangePasswordPage.vue?vue&type=script&lang=js"
export * from "./ChangePasswordPage.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordPage.vue?vue&type=style&index=0&id=4c844c3a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c844c3a",
  null
  
)

export default component.exports